<template>
  <div class="login">
      <!-- 保障 -->
      <div class="Guarantee">
        <div
          class="Guarantee-box"
          v-for="(itemss, indexss) in list"
          :key="indexss"
        >
          <div class="Guarantee-img">
            <img :src="itemss.img" alt="" />
          </div>
          <div>
            <div class="Guarantee-name">{{ itemss.name }}</div>
            <div class="Guarantee-text">
              {{ itemss.lujin }}
            </div>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        
      list: [
        {
          name: "保证金保障",
          lujin: "拍卖机构会保证您金额来往的安全",
          img: require("../assets/image/gua1.png"),
        },
        {
          name: "拍卖风险体系",
          lujin: "对软硬件故障、人为事件进行防护",
          img: require("../assets/image/gua2.png"),
        },
        {
          name: "诚信服务保障",
          lujin: "诚信、安全始终放在第一位",
          img: require("../assets/image/gua3.png"),
        },
      ],
    };
  },
  components: {
  },
  mounted() {},
  methods: {
  },
};
</script>
<style scoped='scoped'>
img {
  width: 100%;
  height: 100%;
}
/*  */
.Guarantee {
  width: 100%;
  padding: 24px 40px;
  background-color: #d9eef6;
  display: flex;
  justify-content: space-between;
}
.Guarantee-box {
  display: flex;
  align-items: center;
}
.Guarantee-img {
  width: 72px;
  height: 72px;
  margin-right: 16px;
}
.Guarantee-text {
  font-size: 16px;
  color: #707070;
  margin-top: 8px;
}
.Guarantee-name {
  font-size: 24px;
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
    
  /*  */
  .Guarantee-img {
    width: 52px;
    height: 52px;
    margin-right: 10px;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  /*  */
  .Guarantee {
    padding: 24px 5px;
  }
  .Guarantee-img {
    width: 45px;
    height: 45px;
    margin-right: 5px;
  }
  .Guarantee-text {
    font-size: 14px;
  }
  .Guarantee-name {
    font-size: 20px;
  }
}
@media only screen and (max-width: 767px) {
  /*  */
  .Guarantee {
    width: 95%;
    margin: 0 auto;
    padding: 24px 5px;
  }
  .Guarantee-box {
    flex-direction: column;
    text-align: center;
    width: 30%;
  }
  .Guarantee-img {
    width: 45px;
    height: 45px;
    margin: 0 auto 10px;
  }
  .Guarantee-text {
    font-size: 14px;
  }
  .Guarantee-name {
    font-size: 16px;
  }
}
</style>
